<template>
  <v-container fluid class="location-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/location/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="locations-table"
              show-select
              single-select
              item-key="_id"
              sort-by="locationrank"
              :footer-props="footer"
              :headers="headers"
              :items="locations"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Location?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteLocation.locationname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteLocation)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.locationimage" size="35">
                  <img v-bind:src="item.locationimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.locationname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.locationname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.locationcode }}</a></p>
                <p class="two-line"><a class="primaryConst--text">{{ item.locationname }}</a></p>
                <p class="two-line">{{ item.locationinfo }}</p>
              </template>
              <template v-slot:item.locationstatus="{ item }">
                <v-chip
                  :color="!item.locationstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.locationstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'locationList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteLocation: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false, width: '10%' },
        { text: 'Rank', value: 'locationrank', width: '8%'},
        { text: 'Type', value: 'locationtype' },
        { text: 'Name', value: 'locationname' },
        { text: 'Status', value: 'locationstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
    }
  },
  computed: {
    ...mapState('Location', ['locations', 'isReceiving', 'isDeleting', 'idToDelete', 'locationsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest","deleteLocationRequest","updateLocationRequest","createLocationRequest"
    ]),
    editItem(item) {
      this.$router.push({ name: 'LocationEdit', params: item })
    },
    deleteItem(item) {
      this.deleteLocationRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteLocation = {
        _id: item._id,
        locationname: item.locationname,
      }
    },
  },
  created () {
    this.getLocationsRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
